import { Aircraft, Hangar, Location, Ramp } from "../types";
import { validateAircraftHeight } from "./bayHeightValidation";

export const checkForAircraftWarnings = (
  aircraft: Aircraft,
  location: Location<Hangar | Ramp>,
  position?: { x: number; y: number }
) => {
  if (!location) {
    return;
  }
  // make sure we have a height to check
  if (!("height" in location)) {
    return;
  }
  // if it's a hangar, then run these checks...
  if (!location.height || !aircraft?.tail_height) {
    return;
  }
  const usableHangarWidth =
    location.width - (location.left_door ?? 0) - (location.right_door ?? 0);
  const newWarnings = [];

  // Use bay-aware height validation
  const heightValidation = validateAircraftHeight(
    aircraft,
    location as Hangar,
    position
  );
  newWarnings.push(...heightValidation.warnings);
  if (aircraft.wingspan >= usableHangarWidth) {
    newWarnings.push(
      `The aircraft wingspan is ${aircraft.wingspan}ft and your hangar door is ${usableHangarWidth}ft wide. This aircraft will not fit.`
    );
  } else if (aircraft.wingspan + 1 >= usableHangarWidth) {
    newWarnings.push(
      `The aircraft wingspan is ${aircraft.wingspan}ft and your hangar door is ${usableHangarWidth}ft wide. Tow with extra caution.`
    );
  }
  return newWarnings;
};